export interface Web3Status {
  status: number;
  account?: string;
  web3?: any;
}

const getWeb3Status = async () => {
  return new Promise<Web3Status>((resolve, reject) => {
    const web3 = (window as any).web3;
    if (!web3) {
      return resolve({ status: 0});
    }

    web3.eth.getAccounts((error: any, accounts: string[]) => {
      if (error) {
        return reject(error);
      }
      if (!accounts || !accounts[0]) {
        return resolve({ status: 1});
      }
      resolve({ status: 2, account: accounts[0], web3 });
    });
  });
};

const getWeb3Network = async () => {
  return new Promise<string>((resolve, reject) => {
    const web3 = (window as any).web3;
    if (!web3) {
      return resolve(null);
    }

    web3.version.getNetwork((err: any, netId: string) => {
      switch (netId) {
        case '1':
          resolve('mainnet');
          break;
        case '4':
          resolve('rinkeby');
          break;
        case '51515':
          resolve('datum-megatron');
          break;
        case '417':
          resolve('datum');
          break;
        default:
          resolve(null);
      }
    });
  });
};

const web3Delay = (tx: string) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => resolve(tx), 700);
  });
};

export default {
  getNetwork: getWeb3Network,
  getStatus: getWeb3Status,
  delay: web3Delay
};
